import React, { useState, useEffect, useContext } from 'react';
import moment from "moment";
import useForm from 'react-hook-form';
import ReactTable from "react-table";
import Datetime from "react-datetime";
import Select from 'react-select';
import CsvDownloader from 'react-csv-downloader';

// @material-ui components
import Tooltip from "@material-ui/core/Tooltip";

// ui components
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Assignment from "@material-ui/icons/Assignment";
import Close from "@material-ui/icons/Close";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import Search from "@material-ui/icons/Search";
import Badge from "beaktShared/components/Badge/Badge.js";
import Timeline from "beaktShared/components/Timeline/Timeline.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import { ValidSelect } from "beaktShared/helpers/validselect";
import EditarAgendamento from "./EditarAgendamento";
import Edit from "@material-ui/icons/Edit";

import TurnedInNot from "@material-ui/icons/TurnedInNot";
import { useTranslation } from 'react-i18next';


//services
import { MaskDate, formateDate, validateDate, convertDate, formateDateandTime, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UsePostApi, UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext, getSessionCookie } from "beaktShared/services/session";

//styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function GestaoAgenda({ clienteId }) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const { register, errors, setError, clearError, getValues, setValue } = useForm({ mode: "onBlur" });

    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const [showModal, setshowModal] = React.useState(false);

    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem, color) => {
        setMensagemNotification(mensagem);
        setColorNotification(color);
        setNotification(true);
        setTimeout(function () {
            setNotification(false);
        }, 6000);
    };

    const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-7, 'days')));
    const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));

    useEffect(() => {
        verifyAcess();
    }, []);

    const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(true);
    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
    const [estabelecimentosId, setestabelecimentosId] = React.useState(0);
    const [listSelectEstabelecimentosSelected, setlistSelectEstabelecimentosSelected] = React.useState([]);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/" + session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'error')
                setisLoadingEstabelecimento(false);
                return false;
            }

            setisLoadingEstabelecimento(false);
            setlistSelectEstabelecimentos(result.data);

            return true;
        });
    };

    const verifyAcess = () => {
        if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            setshowSelectEstabelecimentos(true);
            LoadEstabelecimentos();
        }
        else //Acessando tela pelo modulo Clinica   
        {
            setestabelecimentos([session.estabelecimentoId]);
            setestabelecimentosId(session.estabelecimentoId);
            setshowSelectEstabelecimentos(false)
            handleClickPesquisa();
        }
    };

    const handleEstabelecimentoChange = event => {
        let value = event;
        let lstsAdd = [];
        let lstSelect = [];
        value.map(item => {
            lstsAdd.push(item.estabelecimentoId);

            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId
            });
        });
        setestabelecimentos(lstsAdd);
        setlistSelectEstabelecimentosSelected(lstSelect);
        loadProfissional(lstsAdd);
    };

    const handleClickSelecionarTodosEstabelecimentos = () => {

        let lstsAdd = [];
        let lstSelect = [];
        listSelectEstabelecimentos.map(item => {
            lstsAdd.push(item.estabelecimentoId);

            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId
            });
        });
        setestabelecimentos(lstsAdd);
        setlistSelectEstabelecimentosSelected(lstSelect);
        loadProfissional(lstsAdd);
    };

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() +
            (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    };

    const handleClickPesquisa = () => {
        let data = getValues();

        if (data.dtini === "") {
            setError("dtini", "required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")

        if (data.dtfim === "") {
            setError("dtfim", "required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")

        if (!validateDate(data.dtini)) {
            setError("dtini", "invaliddate", t('error_messsage.invalid_date'))
            return false;
        }
        else
            clearError("dtini")

        if (!validateDate(data.dtfim)) {
            setError("dtfim", "invaliddate", t('error_messsage.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")

        var dataIniConvertida = convertDate(data.dtini);
        var dataFimConvertida = convertDate(data.dtfim);

        if (monthDiff(dataIniConvertida, dataFimConvertida) > 1) {
            showNotification(t('information_message.select_a_period_of_a_maximum_of_1_months'), 'danger')
            return false;
        }
        
        let obj = {
            dataIni: dataIniConvertida,
            dataFim: dataFimConvertida,
            statusAgendamento: StatusAgendamentoSelected,
            estabelecimentos: estabelecimentos,
            profissionalId: selectProfissional,
            servicos: servicoProfissional,
        };

        loadAgendamentos(obj);
    };
    
    const [StatusOptions, setStatusOptions] = React.useState([
        { text: "Todos", value: null },
        { text: "Pendente", value: 0 },
        { text: "Confirmado", value: 1 },
        { text: "Cancelado", value: 2 },
        { text: "Removido", value: 3 },
        { text: "Faltou", value: 4 },
        { text: "Compareceu", value: 5 },
        { text: "Comprou", value: 6 }
    ]);

    const [StatusAgendamentoSelected, setStatusAgendamentoSelected] = React.useState(null);
    const hanndleStatusAgendamentoChange = (event) => {
        let value = event
        setStatusAgendamentoSelected(value);
        setValue("statusagendamento", value);
    };

    const verifyendpoint = () => {
        let endPoint = "";
        if (clienteId)
            endPoint = "agendamentos/cliente/" + clienteId + "/" + session.estabelecimentoId
        else
            endPoint = "agendamentos/completo"
        return endPoint;
    };
    const loadAgendamentos = (obj) => {
        const endPoint = verifyendpoint();
        setisLoadingList(true);
        UsePostApi(endPoint, obj).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                setisLoadingList(false);
                return false;
            }
            loadDataCsv(result.data);
            var lstdata = [];
            result.data.map(item => {

                var status = "";
                if (item.statusAgendamento === 0)
                    status = (<Badge color="info">{t('label.pending')} </Badge>)
                else if (item.statusAgendamento === 1)
                    status = (<Badge color="success">{t('agenda.confirmed')} </Badge>)
                else if (item.statusAgendamento === 2)
                    status = (<Badge color="danger">{t('agenda.canceled')} </Badge>)
                else if (item.statusAgendamento === 3)
                    status = (<Badge color="gray">{t('agenda.removed')} </Badge>)
                else if (item.statusAgendamento === 4)
                    status = (<Badge color="warning">{t('agenda.missed')} </Badge>)
                else if (item.statusAgendamento === 5)
                    status = (<Badge color="primary">{t('agenda.showed_up')} </Badge>)

                var ag = {
                    dataF: formateDate(item.data),
                    status: status,
                    ...item
                }
                lstdata.push(ag);
            });

            setlist(lstdata);
            setisLoadingList(false);
            setloadingTable(false);
            return true;
        });
    };

    // *******************************************************************************
    // ********************************** CABEÇALHO CSV **********************************
    // *******************************************************************************

    const columnsCSV = [
        { displayName: "Estabelecimento", id: "estabelecimento" },
        { displayName: "Data", id: "dataF" },
        { displayName: "Horário", id: "horaInicio" },
        { displayName: "Cliente", id: "nomeCliente" },
        { displayName: "Profissional", id: "nomeProfissional" },
        { displayName: "Serviço", id: "descricaoServico" },
        { displayName: "Status Agendamento", id: "status" },
        { displayName: "Contratos", id: "contratos" }
    ];

    // *******************************************************************************
    // ************************** CARREGAR ITENS DO CSV ******************************
    // *******************************************************************************

    const [dataCSV, setdataCSV] = React.useState([]);
    const [loadingTable, setloadingTable] = React.useState(false);

    const loadDataCsv = (data) => {
        let dtCsv = [];

        data.map(item => {
            var obj = {
                estabelecimento: item.estabelecimento,
                dataF: formateDate(item.data),
                horaInicio: item.horaInicio,
                nomeCliente: item.nomeCliente,
                nomeProfissional: item.nomeProfissional,
                descricaoServico: item.descricaoServico,
                status: item.statusAgendamento == 0 ? "Pendente" : item.statusAgendamento == 1 ? "Confirmado" :
                    item.statusAgendamento == 2 ? "Cancelado" : item.statusAgendamento == 3 ? "Removido" :
                        item.statusAgendamento == 4 ? "Faltou" : item.statusAgendamento == 5 ? "Compareceu" : "",
                contratos: item.contratos
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
    };

    const [historico, sethistorico] = React.useState([]);
    const handleHistorico = (row) => {
        UseGetApiSimple("agendamentos/historico/" + row.agendamentoId).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                return false;
            }
            var dadosHistorico = result.data;
            const stories = [];
            var bside = false;
            for (var i = 0; i < dadosHistorico.length; i++) {
                bside = bside ? false : true;
                var dtag = "";
                if (dadosHistorico[i].dataAgendamento !== null)
                    dtag = formateDate(dadosHistorico[i].dataAgendamento);

                var dtlog = "";
                if (dadosHistorico[i].dataLog !== null)
                    dtlog = formateDateandTime(dadosHistorico[i].dataLog);

                var hini = "";
                if (dadosHistorico[i].horaInicioAgendamento !== null) {
                    let horaslit = dadosHistorico[i].horaInicioAgendamento.split(":");
                    hini = horaslit[0] + ":" + horaslit[1];
                }

                var hend = "";
                if (dadosHistorico[i].horaFimAgendamento !== null) {
                    let horaslit = dadosHistorico[i].horaFimAgendamento.split(":");
                    hend = horaslit[0] + ":" + horaslit[1];
                }

                var acao = "";
                if (dadosHistorico[i].acao === 0)
                    acao = t('label.inserted');
                if (dadosHistorico[i].acao === 1)
                    acao = t('label.changed');

                var sto = {
                    inverted: bside ? true : false,
                    badgeColor: verifyColorByStatus(dadosHistorico[i].statusAgendamento),
                    titleColor: verifyColorByStatus(dadosHistorico[i].statusAgendamento),
                    badgeIcon: TurnedInNot,
                    title: crateTextStatus(dadosHistorico[i].statusAgendamento),
                    body: (
                        <div>
                            <b>{t('label.date')}:</b> {dtag} às {hini} - {hend}
                            <br /><b>{t('label.client')}:</b> {dadosHistorico[i].clienteAgendamento.nome}
                            <br /><b>{t('label.professional')}:</b> {dadosHistorico[i].profissionalAgendamento.nome}
                            <br /><b>{t('label.service')}:</b> {dadosHistorico[i].servicoAgendamento.descricao}
                            <br /><b>{t('label.obs')}:</b> {dadosHistorico[i].obsAgendamento == null ? dadosHistorico[i].agendamento.obs : dadosHistorico[i].obsAgendamento}
                            <br /><br />
                            <div style={{ fontSize: '11px', textAlign: 'right' }}>
                                <b>{acao} {t('label.by')}: {dadosHistorico[i].usuarioMudanca.nome} </b>
                                <br /><b> {t('agenda.recorded_log')} {dtlog}</b>
                            </div>
                        </div>
                    )
                };
                stories.push(sto);
            }
            sethistorico(stories);
            setshowModal(true);
        });
    };

    const crateTextStatus = (statusAgendamento) => {

        if (statusAgendamento === 0)
            return t('agenda.pending_scheduling')
        else if (statusAgendamento === 1)
            return t('agenda.confirmed_schedule')
        else if (statusAgendamento === 2)
            return t('agenda.schedule_canceled')
        else if (statusAgendamento === 3)
            return t('agenda.schedule_removed')
        else if (statusAgendamento === 4)
            return t('agenda.client_missed')
        else if (statusAgendamento === 5)
            return t('agenda.client_attended')

        return t('error_message.status_not_found')
    };

    const verifyColorByStatus = (status) => {
        if (status === 0)
            return "info";
        else if (status === 1)
            return "success";
        else if (status === 2)
            return "danger";
        else if (status === 3)
            return "gray";
        else if (status === 4)
            return "warning";
        else if (status === 5)
            return "primary";
    };
    const [showModalEdit, setshowModalEdit] = React.useState(false);
    const [item, setItem] = useState({});

    const handleEdit = row => {
        setItem(row);
        setshowModalEdit(true);
    };

    const handleReturnModalEditAgendamento = () => {
        showNotification("Agendamento editado com sucesso!", 'success');
        var s = getSessionCookie();
        handleClickPesquisa();
    };

    const columnsProp = [
        {
            Header: "Estabelecimento",
            accessor: "estabelecimento"
        },
        {
            Header: t('label.date'),
            accessor: "dataF"
        },
        {
            Header: t('label.time'),
            accessor: "horaInicio"
        },
        {
            Header: t('label.client'),
            accessor: "nomeCliente"
        },
        {
            Header: t('label.professional'),
            accessor: "nomeProfissional"
        },
        {
            Header: t('label.service'),
            accessor: "descricaoServico"
        },
        {
            Header: t('label.status'),
            accessor: "status",
            sortable: false,
            filterable: false
        },
        {
            Header: t('label.contract'),
            accessor: "contratos"
        }]

    const columnsPropClinic = [
        {
            Header: t('label.date'),
            accessor: "dataF"
        },
        {
            Header: t('label.time'),
            accessor: "horaInicio"
        },
        {
            Header: t('label.professional'),
            accessor: "nomeProfissional"
        },
        {
            Header: t('label.service'),
            accessor: "descricaoServico"
        },
        {
            Header: t('label.status'),
            accessor: "status",
            sortable: false,
            filterable: false
        },
        {
            Header: t('label.contract'),
            accessor: "contratos"
        }]

    //Botão de editar agendamento NÃO aparece para a franquia, apenas para a Clínica
    const columnsAcao = [
        {
            Cell: row => (
                <div className="actions-right">
                    
                    {(row.original.statusAgendamento === 0 && !session.franquiaId) &&
                        <Button
                            justIcon
                            round
                            simple
                            color="success"
                            className="edit"
                            onClick={() => handleEdit(row.original)}
                        >
                            <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                                <Edit />
                            </Tooltip>
                        </Button>
                    }
                    <Button
                        justIcon
                        round
                        simple
                        color="info"
                        className="info"
                        onClick={() => handleHistorico(row.original)}
                    >
                        <Search />
                    </Button>{" "}
                </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    let columns = "";
    if (clienteId)
        columns = [...columnsPropClinic, ...columnsAcao];
    else
        columns = [...columnsProp, ...columnsAcao];

    let styledif = {};
    if (clienteId) {
        styledif = {
            boxShadow: 'none'
        }
    };

    const [mensagemProfissional, setMensagemProfissional] = React.useState('Selecione o estabelecimento');
    const [isLoadingProfissional, setIsloadingProfissional] = React.useState(false);
    const [listSelectProfissional, setListSelectProfissional] = React.useState([]);
    const [selectProfissional, setSelectProfissional] = React.useState(null);
    const loadProfissional = (obj) => {
        if (obj.length > 0) {
            setIsloadingProfissional(true);
            const endPoint = "agendamentos/profissionais";
            UsePostApi(endPoint, obj).then(result => {
                if (result.status !== 200) {
                    showNotification(result.message, 'danger');
                    setIsloadingProfissional(false);
                    return false;
                }
                let lista = result.data || [];

                if (lista.length > 0) {
                    lista = [{ profissional_Id: 0, profissional_Text: 'Todos' }, ...lista];
                    setMensagemProfissional('Nenhum profissional encontrado');
                    limpaServicoProfissional();
                } 
                else {
                    setMensagemProfissional('Não existe profissional cadastrado');
                    limpaServicoProfissional();
                }

                setListSelectProfissional(lista);
                setIsloadingProfissional(false);
            });
        }
        else {
            limpaProfissional();
            limpaServicoProfissional();
        }
    };

    const limpaProfissional = () => {
        setSelectProfissional(null);
        setMensagemProfissional('Selecione o estabelecimento');
        setListSelectProfissional([]);
    };

    const handleProfissionalChange = (event) => {
        if (event) {
            limpaServicoProfissional();
            setSelectProfissional(event.profissional_Id);
            loadServicoProfissional(event.profissional_Id);
        } else {
            setSelectProfissional(null);
        }
    };

    const [mensagemServicoProfissional, setMensagemServicoProfissional] = React.useState('Selecione o profissional');
    const [isLoadingServicoProfissional, setIsLoadingServicoProfissional] = React.useState(false);
    const [listSelectServicoProfissional, setListSelectServicoProfissional] = React.useState([]);
    const [selectServicoProfissional, setSelectServicoProfissional] = React.useState([]);
    const [servicoProfissional, setServisoProfissional] = React.useState([]);

    const loadServicoProfissional = (profissionalId) => {
    if (profissionalId > 0) {
        setIsLoadingServicoProfissional(true);
        const endPoint = "agendamentos/profissionalServicos/" + profissionalId;

        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'error');
                setIsLoadingServicoProfissional(false);
                return;
            }

            const lista = result.data || [];

            // Corrigido o texto
            if (lista.length > 0) {
                setMensagemServicoProfissional('Selecione o serviço');
            } else {
                setMensagemServicoProfissional('Não existe serviço cadastrado para o profissional');
            }

            setListSelectServicoProfissional(lista);
            setIsLoadingServicoProfissional(false);
        });
    } else {
        limpaServicoProfissional();
    }
    };

    const limpaServicoProfissional = () => {
        setMensagemServicoProfissional('Selecione o profissional');
        setListSelectServicoProfissional([]);
        setSelectServicoProfissional([]);
        setServisoProfissional([]);
    };
    
    const handleServicoProfissionalChange = (values) => {
        const lista = values || [];
        const ids = lista.map(s => s.servico_Id);
        setSelectServicoProfissional(lista);
        setServisoProfissional(ids);
    };
        
    return (
        <GridContainer>

            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />

            <GridItem xs={12}>
                <Card style={styledif}>
                    <CardHeader color="primary" icon>
                        <CardIcon color="primary">
                            <Assignment />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>
                            {t('agenda.agenda_management')}
                        </h4>
                    </CardHeader>
                    <CardBody style={{ overflow: "visible", position: "relative", zIndex: 1 }}>
                        {
                            showSelectEstabelecimentos &&
                            <>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <FormControl fullWidth className={classes.formControl} style={{ marginBottom: '20px' }}>
                                            <label className={errors.estabelecimentos ? "select__label select__label_error" : "select__label"}>{t('label.establishment') + " *"} </label>
                                            <Select
                                                menuPortalTarget={document.body}
                                                classNamePrefix="select"
                                                styles={ValidSelect(errors.estabelecimentos ? true : false)}
                                                isMulti={true}
                                                isLoading={isLoadingEstabelecimento}
                                                name="estabelecimento"
                                                placeholder="Selecione..."
                                                options={listSelectEstabelecimentos}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                                value={listSelectEstabelecimentos.filter(({ estabelecimentoId }) => estabelecimentos.indexOf(estabelecimentoId) != -1)}
                                                onChange={(value) => handleEstabelecimentoChange(value || [])}
                                                ref={() => register({ name: "estabelecimento" })}
                                                noOptionsMessage={() => 
                                                    isLoadingEstabelecimento 
                                                        ? "Carregando estabelecimentos..." 
                                                        : "Não existe(m) estabelecimento(s) cadastrado(s)"
                                                }
                                            />
                                            {errors.estabelecimentos &&
                                                <FormHelperText>
                                                    <span className="obg">{t('label.select_an_establishment')} </span>
                                                </FormHelperText>}

                                            <div style={{ textAlign: 'right', marginTop: '3px' }}>
                                                <a href="#" onClick={() => handleClickSelecionarTodosEstabelecimentos()} style={{ marginTop: '10px' }}>
                                                    {t('label.select_all_establishments')}
                                                </a>
                                            </div>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>

                                <GridContainer style={{ marginBottom: '20px'}}>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl} style={{ marginBottom: '20px' }}>
                                            <label className="select__label">
                                                {t('label.professional')} 
                                            </label>
                                            <Select
                                                menuPortalTarget={document.body}
                                                classNamePrefix="select" 
                                                name="profissional"
                                                placeholder="Selecione..."
                                                isMulti={false}
                                                isLoading={isLoadingProfissional}
                                                options={listSelectProfissional}
                                                noOptionsMessage={() => 
                                                    isLoadingProfissional 
                                                        ? "Carregando profissionais..." 
                                                        : mensagemProfissional
                                                }
                                                getOptionLabel={({ profissional_Text }) => profissional_Text}
                                                getOptionValue={({ profissional_Id }) => profissional_Id}
                                                onChange={(value) => handleProfissionalChange(value || [])}
                                                value={listSelectProfissional.find(x => x.profissional_Id === selectProfissional) || null} 
                                                ref={() => register({ name: "profissional" })}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl} style={{ marginBottom: '20px' }}>
                                            <label className="select__label">
                                                {t('label.service')} 
                                            </label>
                                            <Select
                                                menuPortalTarget={document.body}
                                                classNamePrefix="select" 
                                                name="servico"
                                                placeholder="Selecione..."
                                                isMulti={true}
                                                isLoading={isLoadingServicoProfissional}
                                                options={listSelectServicoProfissional}
                                                noOptionsMessage={() => 
                                                    isLoadingServicoProfissional 
                                                        ? "Carregando serviço(s)..." 
                                                        : mensagemServicoProfissional
                                                }
                                                getOptionLabel={({ servico }) => servico}
                                                getOptionValue={({ servico_Id }) => servico_Id}
                                                onChange={handleServicoProfissionalChange}
                                                value={selectServicoProfissional}
                                                ref={() => register({ name: "servico" })}
                                            />
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                            </>
                        }
                        <GridContainer>
                            <GridItem xs={12} sm={6} md={3}>
                                <FormControl fullWidth className={classes.formControl}>
                                    <label className={errors.dtini ? "select__label select__label_error" : "select__label"}>
                                        {t('label.ini_date') + " *"}  </label>
                                    <Datetime
                                        locale={getLocale()}
                                        dateFormat={getStringFormatDate()}
                                        timeFormat={false}
                                        name="dtini"
                                        defaultValue={dtini}
                                        value={dtini}
                                        onChange={date => { setdtini(date) }}
                                        inputProps={{ name: "dtini", ref: register({ required: true }), readOnly: 'readonly' }}
                                        className={errors.dtini ? "error" : ""}
                                    />
                                    {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                        <span> {errors.dtini.message} </span>
                                    </FormHelperText>}
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={3}>
                                <FormControl fullWidth className={classes.formControl}>
                                    <label className={errors.dtfim ? "select__label select__label_error" : "select__label"}>
                                        {t('label.end_date') + " *"}  </label>
                                    <Datetime
                                        locale={getLocale()}
                                        dateFormat={getStringFormatDate()}
                                        timeFormat={false}
                                        name="dtfim"
                                        defaultValue={dtfim}
                                        value={dtfim}
                                        onChange={date => { setdtfim(date) }}
                                        inputProps={{ name: "dtfim", ref: register({ required: true }), readOnly: 'readonly' }}
                                        className={errors.dtfim ? "error" : ""}
                                    />
                                    {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                        <span> {errors.dtfim.message} </span>
                                    </FormHelperText>}
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={3}>
                                <FormControl fullWidth className={classes.formControl}>
                                    <label className={"select__label"}>Status Agendamento</label>
                                    <Select
                                        menuPortalTarget={document.body}
                                        styles={ValidSelect(false)}
                                        classNamePrefix="select"
                                        name="statusagendamento"
                                        placeholder="Todos"
                                        value={StatusOptions.filter(({ value }) => value == StatusAgendamentoSelected)}
                                        getOptionLabel={({ text }) => text}
                                        getOptionValue={({ value }) => value}
                                        options={StatusOptions}
                                        onChange={(value) => hanndleStatusAgendamentoChange(value.value)}
                                        ref={() => register({ name: "statusagendamento" })
                                        }
                                    />
                                    {errors.contratoVenda &&
                                        <FormHelperText>
                                            <span className="obg">{t('label.required')}</span>
                                        </FormHelperText>}
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={6} md={2}>
                                <Button round color="primary"
                                    onClick={e => { handleClickPesquisa() }}>
                                    {t('label.search')}
                                </Button>
                            </GridItem>

                        </GridContainer>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>

                                {dataCSV.length > 0 &&

                                    <div>
                                        <div style={{ float: 'right' }}>
                                            <CsvDownloader
                                                filename="Agendamentos"
                                                columns={columnsCSV}
                                                datas={dataCSV}
                                                separator={";"}>
                                                <Button round color="default" size="sm" >CSV</Button>
                                            </CsvDownloader>
                                        </div><div style={{ clear: 'both' }}></div>
                                    </div>
                                }
                            </GridItem>
                        </GridContainer>

                        <ReactTable
                            loading={isLoadingList}
                            data={list}
                            columns={columns}
                            filterable
                            defaultFilterMethod={noCaseSensitive}
                            defaultPageSize={10}
                            minRows={5}
                            showPaginationBottom={true}
                            className="-striped -highlight"
                            previousText={t('button.previous')}
                            nextText={t('button.next')}
                            loadingText={t('label.loading') + "..."}
                            noDataText={t('information_message.no_records_found') + "!"}
                            pageText={t('label.page')}
                            ofText={t('label.of')}
                            rowsText={t('label.rows')}
                        />
                    </CardBody>
                </Card>
            </GridItem>
            <Dialog
                classes={{
                    root: classes.center + " " + classes.modalRoot,
                    paper: classes.modal + ' ' + classes.modalLarge
                }}
                open={showModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setshowModal(false)}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description"
            >
                <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{ background: '#5c4477' }}
                >
                    <Button
                        justIcon
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="transparent"
                        onClick={() => setshowModal(false)}
                    >
                        <Close className={classes.modalClose} />
                    </Button>
                    <h4 className={classes.modalTitle} style={{ color: 'white' }}>{t('label.historic')} </h4>
                </DialogTitle>
                <DialogContent
                    id="classic-modal-slide-description"
                    className={classes.modalBody}
                    style={{ background: '#f2f2f2' }}
                >
                    <Timeline stories={historico} />

                </DialogContent>
            </Dialog>
            {
                showModalEdit &&
                <Dialog
                    classes={{
                        root: classes.center + " " + classes.modalRoot,
                        paper: classes.modal + ' ' + classes.modalLarge
                    }}
                    open={showModalEdit}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setshowModalEdit(false)}
                    aria-labelledby="classic-modal-slide-title"
                    aria-describedby="classic-modal-slide-description"
                >
                    <EditarAgendamento item={item} callback={handleReturnModalEditAgendamento} closemodal={() => setshowModalEdit(false)} showmodal={showModalEdit} />
                </Dialog>
            }

        </GridContainer>

    );
}

